import React from 'react';
import { Container, Box, Typography } from '@mui/material';

const TermsAndConditions = () => {

    return (
        <Box sx={{ backgroundColor: "#e6f2ff", py: 6 }}>
            <Container>
                <Box sx={{ textAlign: 'center', mb: 4 }}>
                    <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
                        Terms and Conditions
                    </Typography>
                </Box>

                <Box sx={{ mb: 4 }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                        1. Acceptance of Terms
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        By accessing or using the services provided by MC3 Smartech Software Company ("we," "our," or "us"), you agree to comply with and be bound by these Terms. If you do not agree to these Terms, please do not use our website or services.
                    </Typography>

                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                        2. Use of Services
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        MC3 Smartech Software Company offers various software development and IT services. By using our services, you agree to use them only for lawful purposes and comply with all applicable laws and regulations.
                    </Typography>

                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                        3. User Accounts
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        In order to access certain features or services, you may be required to create an account with us. You agree to provide accurate, current, and complete information when creating an account and to maintain the security and confidentiality of your account details.
                    </Typography>

                    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                        4. Intellectual Property
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3 }}>
                        All content on the MC3 Smartech Software Company website, including but not limited to text, images, graphics, logos, and software, is owned or licensed by MC3 Smartech Software Company and is protected by intellectual property laws.
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 3 }}>
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default TermsAndConditions;
